<!-- <div
  class="fixed left-0 top-0 w-64 h-screen bg-white border-r border-gray-200 flex flex-col z-10"
>
  Logo/Header Area
  <div class="h-14 bg-gray-300 m-5 flex items-center justify-center">
    Placeholder for logo
  </div>

  Navigation Menu
  <nav class="flex-1 px-4 py-6 space-y-1">
    Dashboard
    <a
      (click)="navigateTo('/dashboard')"
      [class]="getNavItemClass('/dashboard')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ dashboard.svg"
        class="w-5 h-5 text-[#171771] rounded mr-3"
        [class]="activeRoute === '/dashboard' ? 'text-black' : 'text-white'"
      />
      <span class="text-xs text-[#171771]">Dashboard</span>
    </a>

    Coupon
    <a
      (click)="navigateTo('/coupon')"
      [ngClass]="getNavItemClass('/coupon')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ ticket.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/coupon',
          'text-black': activeRoute !== '/coupon'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/coupon',
          'text-black': activeRoute !== '/coupon'
        }"
      >
        Coupon
      </span>
    </a>

    Business
    <a
      (click)="navigateTo('/business-listing')"
      [ngClass]="getNavItemClass('/business-listing')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ storefront.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/business-listing',
          'text-black': activeRoute !== '/business-listing'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/business-listing',
          'text-black': activeRoute !== '/business-listing'
        }"
      >
        Business
      </span>
    </a>

    Customer
    <a
      (click)="navigateTo('/customer')"
      [ngClass]="getNavItemClass('/customer')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ happy.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/customer',
          'text-black': activeRoute !== '/customer'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/customer',
          'text-black': activeRoute !== '/customer'
        }"
      >
        Customer
      </span>
    </a>

    Category
    <a
      (click)="navigateTo('/category')"
      [ngClass]="getNavItemClass('/category')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ star.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/category',
          'text-black': activeRoute !== '/category'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/category',
          'text-black': activeRoute !== '/category'
        }"
      >
        Category
      </span>
    </a>

    Membership
    <a
      (click)="navigateTo('/membership')"
      [ngClass]="getNavItemClass('/membership')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_membership.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/membership',
          'text-black': activeRoute !== '/membership'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/membership',
          'text-black': activeRoute !== '/membership'
        }"
      >
        Membership
      </span>
    </a>

    Banner
    <a
      (click)="navigateTo('/banner')"
      [ngClass]="getNavItemClass('/banner')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_images-outline.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/banner',
          'text-black': activeRoute !== '/banner'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/banner',
          'text-black': activeRoute !== '/banner'
        }"
      >
        Banner
      </span>
    </a>

    Staff
    <a
      (click)="navigateTo('/staff')"
      [ngClass]="getNavItemClass('/staff')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ staff.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/staff',
          'text-black': activeRoute !== '/staff'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/staff',
          'text-black': activeRoute !== '/staff'
        }"
      >
        Staff
      </span>
    </a>

    Access Role
    <a
      (click)="navigateTo('/access-role')"
      [ngClass]="getNavItemClass('/access-role')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <img
        src="../../../../assets/icon/icon_ access role.svg"
        class="w-5 h-5 mr-3"
        [ngClass]="{
          'filter brightness-0 invert': activeRoute === '/access-role',
          'text-black': activeRoute !== '/access-role'
        }"
      />
      <span
        class="font-mulish text-xs"
        [ngClass]="{
          'text-white': activeRoute === '/access-role',
          'text-black': activeRoute !== '/access-role'
        }"
      >
        Access Role
      </span>
    </a>
  </nav>

  Footer
  <div class="px-4 py-4">
    <p class="text-xs text-[#BCBCBC] font-mulish">© Snatch It Pte Ltd 2025</p>
  </div>
</div> -->

<!-- ================= {A} =============== -->
<!-- Sidebar wrapper -->
<div
  class="fixed left-0 top-0 w-64 h-screen bg-white border-r border-gray-200 flex flex-col z-10"
>
  <!-- Logo/Header -->
  <div class="h-14 w-[160px] m-5 flex items-center justify-center">
    <!-- Placeholder for logo -->
    <ion-img
      src="../../../../assets/img/logo_fullLockup_colour_horiz 1.svg"
    ></ion-img>
  </div>

  <!-- <div class="px-4 mb-3">
    <div
      class="flex items-center px-4 py-3 rounded-lg bg-secondary"
    >
      <img
        src="../../../assets/icon/image_ profile.svg"
        class="w-5 h-5 mr-3"
        alt="Profile"
      />
      <span class="text-xs font-semibold text-[#171717] whitespace-nowrap">
        Name : {{ g.profile.firstName }} {{ g.profile.lastName }}
      </span>
    </div>
  </div> -->

  <!-- User Info -->
  <div class="px-4 mb-4 space-y-2">
    <!-- Name (tab style) -->
    <div class="flex items-center px-4 py-3 rounded-lg bg-secondary">
      <img
        src="../../../assets/icon/image_ profile.svg"
        class="w-5 h-5 mr-3"
        alt="Profile"
      />
      <span class="text-xs font-semibold text-[#171717] whitespace-nowrap">
        {{ g.profile.firstName }} {{ g.profile.lastName }}
      </span>
    </div>

    <!-- Points (merchant only) -->
    <div
      class="bg-[#2F66FF] rounded-full h-[35px] w-full"
      *ngIf="g.profile?.accessType === 'merchant'"
    >
      <div class="flex items-center justify-center h-full px-4">
        <img
          class="h-4 w-4 mr-1"
          src="../../../../assets/img/image_ points.svg"
          alt="Points"
        />
        <span
          class="text-white font-mulish text-xs font-extrabold whitespace-nowrap"
        >
          {{ this.walletPoints }} points
        </span>
        <img
          class="h-4 w-4 ml-2 cursor-pointer"
          src="../../../../assets/img/icon_ add.svg"
          alt="Add"
          (click)="goToWallet()"
        />
      </div>
    </div>
  </div>

  <!-- Navigation scrollable section -->
  <div class="flex-1 overflow-y-auto px-4 pb-6 sidebar-content">
    <!-- Main -->
    <div
      class="mb-4"
      *ngIf="
        menuHelper.shouldShowMenuItem('/dashboard') ||
        menuHelper.shouldShowMenuItem('/coupon')
      "
    >
      <p class="text-xs font-bold mb-2 text-[#171717]">Main</p>

      <!-- Dashboard -->
      <a
        *ngIf="menuHelper.shouldShowMenuItem('/dashboard')"
        (click)="navigateTo('/dashboard')"
        [class]="getNavItemClass('/dashboard')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          src="../../../../assets/icon/icon_ dashboard.svg"
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Dashboard</span>
      </a>

      <!-- Coupon  -->
      <a
        *ngIf="
          menuHelper.shouldShowMenuItem('/coupon') && g.hasAnyAccess('/coupon')
        "
        (click)="navigateTo('/coupon')"
        [class]="getNavItemClass('/coupon')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/coupon')
              ? '../../../../assets/img/icon_ ticket_white.svg'
              : '../../../../assets/icon/icon_ ticket.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Coupon</span>
      </a>
    </div>
    <hr
      *ngIf="
        menuHelper.shouldShowMenuItem('/dashboard') ||
        menuHelper.shouldShowMenuItem('/coupon')
      "
      class="border-t border-gray-200 my-4"
    />

    <!-- Advertisement -->
    <div
      class="mb-4"
      *ngIf="
        menuHelper.shouldShowMenuItem('/banner') ||
        menuHelper.shouldShowMenuItem('/campaign') ||
        menuHelper.shouldShowMenuItem('/gps')
      "
    >
      <p class="text-xs font-bold mb-2 text-[#171717]">Advertisement</p>
      
      <a
        *ngIf="menuHelper.shouldShowMenuItem('/banner') && g.hasAnyAccess('/banner')"
        (click)="navigateTo('/banner')"
        [class]="getNavItemClass('/banner')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <!-- <img
          src="../../../../assets/img/images-outline 1_white.svg"
          class="w-5 h-5 mr-3"
        /> -->

        <img
          [src]="
            isParentActive('/banner')
              ? '../../../../assets/img/images-outline 1_white.svg'
              : '../../../../assets/icon/icon_images-outline.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Banner</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/campaign') && g.hasAnyAccess('/campaign')"
        (click)="navigateTo('/campaign')"
        [class]="getNavItemClass('/campaign')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/campaign')
              ? '../../../../assets/img/icon_ steal_white.svg'
              : '../../../../assets/img/icon_ steal.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Campaign</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/gps') && g.hasAnyAccess('/gps')"
        (click)="navigateTo('/gps')"
        [class]="getNavItemClass('/gps')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/gps')
              ? '../../../../assets/img/icon_ compass_white.svg'
              : '../../../../assets/img/icon_ compass.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">GPS</span>
      </a>
    </div>
    <hr
      *ngIf="
        menuHelper.shouldShowMenuItem('/banner') ||
        menuHelper.shouldShowMenuItem('/campaign') ||
        menuHelper.shouldShowMenuItem('/gps')
      "
      class="border-t border-gray-200 my-4"
    />

    <!-- Contact -->
    <div
      class="mb-4"
      *ngIf="
        menuHelper.shouldShowMenuItem('/business-listing') ||
        menuHelper.shouldShowMenuItem('/customer')
      "
    >
      <p class="text-xs font-bold mb-2 text-[#171717]">Contact</p>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/business-listing')"
        (click)="navigateTo('/business-listing')"
        [class]="getNavItemClass('/business-listing')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/business-listing')
              ? '../../../../assets/img/icon_ storefront_white.svg'
              : '.../../../../assets/icon/icon_ storefront.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Business</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/customer')"
        (click)="navigateTo('/customer')"
        [class]="getNavItemClass('/customer')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/customer')
              ? '../../../../assets/img/icon_ happy_white.svg'
              : '../../../../assets/icon/icon_ happy.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Customer</span>
      </a>

      <!-- <a
        (click)="navigateTo('/staff')"
        [class]="getNavItemClass('/staff')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          src="../../../../assets/icon/icon_ staff.svg"
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Staff</span>
      </a> -->
    </div>
    <hr
      *ngIf="
        menuHelper.shouldShowMenuItem('/business-listing') ||
        menuHelper.shouldShowMenuItem('/customer')
      "
      class="border-t border-gray-200 my-4"
    />

    <!-- Configuration -->
    <div
      *ngIf="
        menuHelper.shouldShowMenuItem('/advertisement') ||
        menuHelper.shouldShowMenuItem('/membership') ||
        menuHelper.shouldShowMenuItem('/category') ||
        menuHelper.shouldShowMenuItem('/accessRole-list')
      "
    >
      <p
        class="text-xs font-bold mb-2 text-[#171717]"
        style="font-style: Bold; font-size: 12px"
      >
        Configuration
      </p>

      <a
      *ngIf="menuHelper.shouldShowMenuItem('/interest-listing')"
      (click)="navigateTo('/interest-listing')"
      [class]="getNavItemClass('/interest-listing')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
    >
      <!-- <img
        [src]="
          isParentActive('/interest-listing')
            ? '../../../../assets/img/icon_ advertisement_white.svg'
            : '../../../../assets/img/icon_ advertisement.svg'
        "
        class="w-5 h-5 mr-3"
      /> -->
      <ion-icon name="star-outline" class="w-4 h-4 mr-3"></ion-icon>
      <span class="text-xs">Interest</span>
    </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/advertisement')"
        (click)="navigateTo('/advertisement')"
        [class]="getNavItemClass('/advertisement')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/advertisement')
              ? '../../../../assets/img/icon_ advertisement_white.svg'
              : '../../../../assets/img/icon_ advertisement.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Advertisement</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/membership')"
        (click)="navigateTo('/membership')"
        [class]="getNavItemClass('/membership')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/membership')
              ? '../../../../assets/img/diamond-outline_white.svg'
              : '../../../../assets/icon/icon_membership.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <!-- <span class="text-xs">Membership</span> -->
        <span class="text-xs">Membership</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/category')"
        (click)="navigateTo('/category')"
        [class]="getNavItemClass('/category')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          [src]="
            isParentActive('/category')
              ? '../../../../assets/img/icon_ cube_white.svg'
              : '../../../../assets/img/icon_ cube.svg'
          "
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Category</span>
      </a>

      <a
        *ngIf="menuHelper.shouldShowMenuItem('/accessRole-list')"
        (click)="navigateTo('/accessRole-list')"
        [class]="getNavItemClass('/accessRole-list')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <img
          src="../../../../assets/icon/icon_ access role.svg"
          class="w-5 h-5 mr-3"
        />
        <span class="text-xs">Access Role</span>
      </a>
    </div>
    <hr
      *ngIf="
        menuHelper.shouldShowMenuItem('/advertisement') ||
        menuHelper.shouldShowMenuItem('/membership') ||
        menuHelper.shouldShowMenuItem('/category') ||
        menuHelper.shouldShowMenuItem('/accessRole-list')
      "
      class="border-t border-gray-200 my-4"
    />

    <div
      class="mb-4"
      *ngIf="menuHelper.shouldShowMenuItem('/transaction-listing') && g.hasAnyAccess('/transaction-listing')"
    >
      <p class="text-xs font-bold mb-2 text-[#171717]">Transaction</p>

      <a
        (click)="navigateTo('/transaction-listing')"
        [class]="getNavItemClass('/transaction-listing')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <!-- <img
          [src]="
            isParentActive('/wallet')
              ? '../../../../assets/img/icon_ storefront_white.svg'
              : '.../../../../assets/icon/icon_ storefront.svg'
          "
          class="w-5 h-5 mr-3"
        /> -->
        <span class="text-xs">Transaction</span>
      </a>
    </div>
    <hr
      *ngIf="menuHelper.shouldShowMenuItem('/transaction-listing')"
      class="border-t border-gray-200 my-4"
    />

    <div
      class="mb-4"
      *ngIf="menuHelper.shouldShowMenuItem('/business-manage-listing') && g.hasAnyAccess('/business-manage-listing')"
    >
      <p class="text-xs font-bold mb-2 text-[#171717]">Business</p>

      <a
        (click)="navigateTo('/business-manage-listing')"
        [class]="getNavItemClass('/business-manage-listing')"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
      >
        <!-- <img
          [src]="
            isParentActive('/wallet')
              ? '../../../../assets/img/icon_ storefront_white.svg'
              : '.../../../../assets/icon/icon_ storefront.svg'
          "
          class="w-5 h-5 mr-3"
        /> -->
        <span class="text-xs">Manage Business</span>
      </a>
    </div>
    <hr
      *ngIf="menuHelper.shouldShowMenuItem('/business-manage-listing')"
      class="border-t border-gray-200 my-4"
    />

    <div
  class="mb-4"
  *ngIf="
    menuHelper.shouldShowMenuItem('/user-profile-listing') &&
    g.hasAnyAccess('/user-profile-listing')
  "
>
  <p class="text-xs font-bold mb-2 text-[#171717]">User</p>

  <a
    (click)="navigateTo('/user-profile-listing')"
    [class]="getNavItemClass('/user-profile-listing')"
    class="flex items-center px-4 py-3 cursor-pointer rounded-lg group"
  >
    <!-- Icon (optional) -->
    <!--
    <img
      [src]="
        isParentActive('/user-profile')
          ? '../../../../assets/icon/icon_user_white.svg'
          : '../../../../assets/icon/icon_user.svg'
      "
      class="w-5 h-5 mr-3"
    />
    -->
    <ion-icon name="person" class="w-4 h-4 mr-3 "></ion-icon>
    
    <span class="text-xs">User Profile</span>
  </a>
</div>

<hr
  *ngIf="menuHelper.shouldShowMenuItem('/user-profile-listing')"
  class="border-t border-gray-200 my-4"
/>

  </div>

  

  <!-- Footer -->
  <div class="px-4 py-4">
    <button
      (click)="logout()"
      class="w-full flex items-center justify-center px-4 py-2 mb-3 text-sm text-white bg-[#E91447] rounded-lg hover:bg-[#d0123d] transition-colors font-mulish"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4 mr-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
        />
      </svg>
      Logout
    </button>
    <p class="text-[10px] text-[#BCBCBC] font-mulish">
      © Snatch It Pte Ltd 2025
    </p>
  </div>
</div>
